<wiz-ngx-charts #chart width="100%" height="100%"></wiz-ngx-charts>
